import React from 'react';
import { type FieldValues, type Path, type PathValue } from 'react-hook-form';

import { useFormElement } from '../useFormElement';

import { BaseCountrySelectInput, type BaseCountrySelectInputProps } from './BaseCountrySelectInput';

export type CountrySelectInputProps<T extends FieldValues, FP extends Path<T>> = Omit<
	BaseCountrySelectInputProps,
	'error' | 'onChange' | 'ref' | 'value'
> & {
	defaultValue?: PathValue<T, FP>;
	name: FP;
};

export function CountrySelectInput<T extends FieldValues, FP extends Path<T> = Path<T>>({
	defaultValue,
	name,
	...props
}: CountrySelectInputProps<T, FP>) {
	const {
		field,
		fieldState: { error }
	} = useFormElement<T, FP>({
		defaultValue,
		name
	});

	return <BaseCountrySelectInput {...field} error={error} {...props} />;
}
